import React from 'react';
import { PermissiosAccordion } from './permission-accordion';
import EntityPermissions from './EntityPermissions';
import CheckBox from '../../../../components/check-box';
import { ApiPermissions, Dict } from '../../../../core';

interface PermissionSelectionViewProps {
  heading: React.ReactNode;
  permissions: ApiPermissions[];
  selectedPermissions?: string[];
  onPermissionSelection?: (
    permission: string | string[],
    selected: boolean
  ) => void;
  disabled?: boolean;
}

const PermissionSelectionView: React.SFC<PermissionSelectionViewProps> = (
  props
) => {
  const {
    permissions,
    selectedPermissions,
    onPermissionSelection,
    heading,
  } = props;

  if (!permissions || !permissions.length) {
    return <div className="main__label">No permissions found</div>;
  }
  if (selectedPermissions) {
    permissions.forEach((per) => {
      // eslint-disable-next-line no-param-reassign
      per.selected = selectedPermissions.includes(per.permission);
    });
  }

  const allSelected = !permissions.find((per) => !per.selected);
  const permissionCount = permissions.filter((per) => per.selected).length;

  const subHeading = allSelected
    ? 'All permissions granted'
    : `${permissionCount || 'No'} permission${
        permissionCount === 1 ? '' : 's'
      } granted`;

  const formatPermissions = () => {
    const servicePermissionsDict: Dict = {};
    permissions.forEach((per) => {
      if (!servicePermissionsDict[per.entity || '']) {
        servicePermissionsDict[per.entity || ''] = [];
      }
      servicePermissionsDict[per.entity || ''].push(per);
    });
    return Object.keys(servicePermissionsDict).map((entity) => {
      return {
        entity,
        permissions: servicePermissionsDict[entity] || [],
      };
    });
  };
  const header = (
    <CheckBox
      id="all_permissions"
      label="Allow All Permissions"
      checked={allSelected}
      // containerStyles={{ bottom: '7px', right: '-6px' }}
      labelClassName="Accordion__title--level-lg font-normal font-weight-semibold text-gray-800"
      onChange={(val) => {
        if (onPermissionSelection) {
          onPermissionSelection(
            permissions.map((per) => per.permission),
            val
          );
        }
      }}
      disabled={props.disabled}
    />
  );
  const servicePermissions = formatPermissions();
  return (
    <PermissiosAccordion
      header={header}
      heading={heading}
      // subHeading={subHeading}
      defaultOpen
      headingLevel="lg"
      level={1}
    >
      {servicePermissions.map((servicePermission) => {
        return (
          <EntityPermissions
            entity={servicePermission}
            onPermissionSelection={onPermissionSelection}
            disabled={props.disabled}
          />
        );
      })}
    </PermissiosAccordion>
  );
};

export default PermissionSelectionView;
